export const CHANGE_PROCEDURE = '@@proceduredropdown/CHANGE_PROCEDURE';

export const ProcedureDropdownActions = {
    CHANGE_PROCEDURE,
};

export const changedProcedure = (procedureId, insuranceMayNotCover) => ({
    type: ProcedureDropdownActions.CHANGE_PROCEDURE,
    procedureId,
    insuranceMayNotCover,
});

export function changeProcedure(newProcedureId, insuranceMayNotCover) {
    return (dispatch) => {
        dispatch(changedProcedure(newProcedureId, insuranceMayNotCover));
    };
}
